/**
 * Backend 401 codes, same rules as the SPK2GO back office:
 * - `session_idle_timeout` / `session_revoked` → sign in again (never refresh)
 * - anything else (incl. `token_stale`, plain expiry) → refresh once and retry
 */

export const SESSION_IDLE_TIMEOUT_CODE = 'session_idle_timeout';
export const SESSION_REVOKED_CODE = 'session_revoked';

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : null;
}

function trimmed(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

/** Reads `code` from `{ code }`, `{ errors: { code } }` or `{ errors: [{ name: "code", message }] }`. */
export function readAuthErrorCode(data: unknown): string {
  const record = asRecord(data);
  if (!record) return '';
  if (trimmed(record.code)) return trimmed(record.code);

  if (Array.isArray(record.errors)) {
    for (const item of record.errors) {
      const error = asRecord(item);
      if (error && trimmed(error.name).toLowerCase() === 'code' && trimmed(error.message)) {
        return trimmed(error.message);
      }
    }
  }
  return trimmed(asRecord(record.errors)?.code);
}

export function canRefreshAfter(status: number, data: unknown): boolean {
  if (status !== 401) return false;
  const code = readAuthErrorCode(data);
  return code !== SESSION_IDLE_TIMEOUT_CODE && code !== SESSION_REVOKED_CODE;
}
